import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useRemoveModelConceptRelationship } from 'src/containers/ProjectDiagram/hooks/remove/useRemoveModelConceptRelationship';
import { ModelConceptRelationshipLink } from 'src/containers/ProjectDiagram/types/diagram';
import { EntityDrawerType } from 'src/store/ui/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import * as copy from 'src/templates/copy';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

type RelationshipContextMenuProps = {
  link: ModelConceptRelationshipLink;
};

export const RelationshipContextMenu: React.VFC<
  RelationshipContextMenuProps
> = ({ link }) => {
  const { projectId } = useRouterParams();
  const dispatch = useReduxDispatch();
  const handleRemoveRelationship = useRemoveModelConceptRelationship();

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.edit}
        onClick={() => {
          const entityValue = link.data.value;
          dispatch(
            uiSlice.actions.changedEntityDrawer({
              projectId,
              drawer: {
                entityValue,
                type: EntityDrawerType.RELATIONSHIP,
              },
            })
          );
        }}
        text={copy.components.projectDiagram.contextMenu.seeDetails}
      />
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={() => handleRemoveRelationship({ key: link.data.key })}
        text={copy.components.projectDiagram.contextMenu.delete}
      />
    </Menu>
  );
};
